<template>
    <CHeader fixed with-subheader light>
        <CToggler   
            in-header
            class="ml-3 d-lg-none"
            @click="$store.commit('toggleSidebarMobile')"
        />
        <CToggler 
            in-header
            class="ml-3 d-md-down-none"
            @click="$store.commit('toggleSidebarDesktop')"
        />
        <CHeaderNav class="mr-4 logout">
            <CHeaderNavItem class="d-md-down-none mx-2">
                <select name="" id="" v-model="uiLang" @change="setLang(uiLang)">
                    <option v-for="option in optionsLang" :key="option.text" :value="option.value">{{option.text}}</option>
                </select>
            </CHeaderNavItem>
            <CHeaderNavItem @click.native="clickLogout" class="d-md-down-none mx-2">
                <CHeaderNavLink >
                    <i class="lni-power-switch">{{adminMark}}</i>{{$t('Sign_out')+userName}}
                </CHeaderNavLink>
            </CHeaderNavItem>
        </CHeaderNav>
    </CHeader>
</template>
<script>
export default {
    name: "TheHeader",
    data() {
        return {
            uiLang: this.$store.state.lang ,//'zh'
            optionsLang: [
                { text: '繁體中文', value: 'zh-TW' },
                { text: 'English', value: 'en' }
            ]
        }
    },
    mounted() {
    },    
    computed: {
        isEmployee() {            
            return this.$store.state.isEmployee;            
        },
        userName (){
            if(this.$userInfo && this.$userInfo.accountName){
                let name =this.$userInfo.accountName;
                if(name.length > 3){
                    name = name.substring(0,3)+ '..';
                }
                return '(' + name + ')';
            }
            return ''
        },
        adminMark (){            
            if(this.$isAdmin){
                return '*';
            }
            return '';
        }
    },
    methods: {
        // 儲存切換的語系
        setLang (value) {
            this.$store.commit('setLang', value);
            this.$i18n.locale = value;
            sessionStorage.setItem('footmark-lang', value);
            //將語系切換後的資料回傳後端
            const url = `${this.$apiUrl_Auth}/ChangeUiLang`;
            const param= {uiLang : value};
            this.axios.post(url, param).then(() => {});
        },
        clickLogout (){            
            this.$store.dispatch('logout',{}).then(() => {
                //location.reload();
                let redirectUrl = this.$store.getters['redirectUrl'];
                if(redirectUrl){
                    location.href = redirectUrl;
                }else{
                    location.reload();
                }
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.logout {
    position: absolute;
    right: 0;
}

select {
    border: 1px solid rgba(0, 0, 21, 0.5);
    border-radius: 4px;
    height: 40px;
    line-height: 40px;

    appearance: none;
    padding: 0 20px;

    color: rgba(0, 0, 21, 0.5);
}
</style>
